export type TCheckLink = {
    [key: string]: {
        badLink: number;
        urls: Array<{ url: string; number: number; maxNumber: number }>;
    };
};
export type TTagSupported = "h2" | "h3" | "a" | "strong" | "i" | "ul" | "ol" | "h2, h3";
export type TNumberOfKeyworks = Record<string, number>;
export const camelCase = (str: string, firstCapital: boolean = false): string => {
    return str.replace(/^([A-Z])|[\s-_](\w)/g, (match, p1, p2, offset) => {
        if (firstCapital && offset === 0) return p1;
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();
    });
};

export const countWord = (str?: string): number => {
    let newStr = str?.replace(/<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g, " ");
    newStr = newStr?.replace(/&nbsp;/g, " ");
    newStr = newStr?.replace(/(^\s*)|(\s*$)/gi, ""); //exclude  start and end white-space
    newStr = newStr?.replace(/[ ]{2,}/gi, " "); //2 or more space to 1
    newStr = newStr?.replace(/\n /, "\n"); // exclude newline with a start spacing
    return newStr !== undefined ? newStr?.split(" ")?.filter((string) => string != "")?.length : 0;
};

export const countString = (str: string, data: string): number => {
    const all = data.match(new RegExp(str, "g")) || [];

    return all.length;
};
export const getTagsInnerText = (tagName: TTagSupported, data: string): string[] => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const allTags = doc.querySelectorAll<HTMLHeadingElement>(tagName);
    const texts: string[] = [];

    allTags.forEach((tag) => {
        if (tag.innerText.match(/[\S\s]+[\S]+/)) {
            texts.push(tag.innerText);
        }
    });

    return texts;
};

export const countTagsInString = (
    tagName: TTagSupported,
    data: string
): { empty: number; noEmpty: number } => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const allTags = doc.querySelectorAll<
        HTMLElement | HTMLAnchorElement | HTMLHeadingElement | HTMLOListElement | HTMLUListElement
    >(tagName);
    const noEmptyTags: Array<HTMLHeadingElement | HTMLAnchorElement | HTMLElement> = [];
    const EmptyTags: Array<HTMLHeadingElement | HTMLAnchorElement | HTMLElement> = [];
    allTags.forEach((tag) => {
        if (tag.innerText.match(/[\S\s]+[\S]+/)) {
            noEmptyTags.push(tag);
        } else {
            EmptyTags.push(tag);
        }
    });

    return { empty: EmptyTags.length, noEmpty: noEmptyTags.length };
};

export const checkLink = (
    data: string,
    links: { url?: any; anchor?: any }[] | undefined | null
): TCheckLink => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const allAnchor = doc.querySelectorAll("a");
    const allValues: TCheckLink = {};
    links?.forEach((link) => {
        let urls = allValues[link.anchor]?.urls;
        if (urls) {
            const index = urls.findIndex((el) => el.url === link.url || `${el.url}/` === link.url);
            if (index !== -1) {
                urls[index].maxNumber += 1;
            } else {
                urls.push({ url: link.url, maxNumber: 1, number: 0 });
            }
        } else {
            urls = [{ url: link.url, maxNumber: 1, number: 0 }];
        }

        allValues[link.anchor.toLowerCase()] = {
            ...allValues[link.anchor],
            urls,
            badLink: 0,
        };
    });

    allAnchor.forEach((a) => {
        if (Object.keys(allValues).includes(a.innerText.toLowerCase())) {
            const url = a.getAttribute("href");
            const urls = allValues[a.innerText.toLowerCase()].urls;
            let badLink = 0;
            if (url) {
                const index = urls.findIndex((el) => el.url === url || `${el.url}/` === url);
                if (index !== -1) {
                    urls[index].number++;
                } else {
                    badLink++;
                }

                allValues[a.innerText.toLowerCase()] = {
                    ...allValues[a.innerText],
                    urls,
                    badLink,
                };
            }
        }
    });

    return allValues;
};

export const linksPassTest = (
    checkedLinks: TCheckLink,
    links: { url?: any; anchor?: any }[] | undefined | null
): boolean => {
    return !links
        ? true
        : links.every((link) => {
              if (checkedLinks[link.anchor.toLowerCase()]?.badLink !== 0) {
                  return false;
              }
              return checkedLinks[link.anchor.toLowerCase()].urls.every((el) => {
                  return el.number === el.maxNumber;
              });
          });
};

export const copyLinkToClipboard = (word: string, url: string) => {
    const anchor = document.createElement("a");
    // Set the text and href attributes
    anchor.textContent = word;
    anchor.href = url;

    // Append the anchor to the document body
    document.body.appendChild(anchor);
    // Select the anchor element
    const range = document.createRange();
    window?.getSelection()?.removeAllRanges();
    range.selectNode(anchor);
    window?.getSelection()?.addRange(range);

    // Execute the copy command
    document.execCommand("copy");

    // Remove the anchor element from the document body
    document.body.removeChild(anchor);
};
